import * as React from "react";
import type { SVGProps } from "react";
const SvgMidFloorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M26.25 25.813h-3.062V5.25a.44.44 0 0 0-.352-.429l-17.5-3.5a.437.437 0 0 0-.524.429v24.063H1.75a.437.437 0 1 0 0 .875h24.5a.438.438 0 0 0 0-.875m-3.937-6.563H5.688v-8.312h16.625zm0-13.641v4.454H5.688v-7.78zM5.688 20.125h16.625v5.688H5.688z"
    />
    <path
      fill="#858585"
      d="M15.094 14.219a1.094 1.094 0 1 0-2.188 0 1.094 1.094 0 0 0 2.188 0m-1.313 0a.22.22 0 1 1 .439 0 .22.22 0 0 1-.439 0"
    />
    <path
      fill="#858585"
      d="M13.308 18.048a.895.895 0 0 0 1.384 0c.383-.478 1.933-2.65 1.933-3.767 0-1.361-1.178-2.469-2.625-2.469s-2.625 1.108-2.625 2.47c0 1.116 1.55 3.288 1.933 3.766m.692-5.36c.965 0 1.75.714 1.75 1.593 0 .632-1.047 2.356-1.738 3.217a.1.1 0 0 1-.022.002c-.693-.863-1.74-2.587-1.74-3.219 0-.879.785-1.594 1.75-1.594"
    />
  </svg>
);
export default SvgMidFloorIcon;
